import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const box: SxStyle = {
  p: 1,
};

export const divider: SxStyle = {
  backgroundColor: (p) => p.palette.primary[100],
};
